import { CircularProgress, Stack, Typography } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom"; // Updated import for react-router-dom
import { logger } from "@services/workers/helpers";

const name = "Switchboard";

interface State {
    accountCode: number;
    callFrom: number;
    newBooking: boolean;
    jobId: string;
    delayedLoad?: boolean;
}

const Switchboard: React.FC<{ parent: string }> = ({ parent }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as State;

    const debugName = `${parent}▷[${name}]`;

    React.useEffect(() => {
        if (state?.newBooking || state?.delayedLoad) {
            logger.debug(debugName, `Switching to booking form with accountCode: ${state.accountCode}, callFrom: ${state.callFrom}, newBooking: ${state.newBooking}, jobId: ${state.jobId}`);
            setTimeout(() => {
                logger.debug(debugName, `Navigating to booking form with accountCode: ${state.accountCode}, callFrom: ${state.callFrom}, newBooking: ${state.newBooking}, jobId: ${state.jobId}`);
                navigate("/booking-form", {
                    replace: true,
                    state,
                });
            }, 100);
        }
    }, [state, debugName, navigate]);

    return (
        <Stack
            sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
            }}
            direction="row"
        >
            <Typography variant="h1">
                {!state?.callFrom ? "Loading form..." : "Connecting call..."}
            </Typography>
            <CircularProgress color="inherit" variant="indeterminate" size={100} />
        </Stack>
    );
};

Switchboard.displayName = name;

export default React.memo(Switchboard);
